import type { Locale } from "date-fns";
import {
  uk,
  enGB,
  ru,
  de,
  bg,
  zhCN,
  nl,
  fr,
  hi,
  it,
  ja,
  pl,
  pt,
  ro,
  es,
  sv,
} from "date-fns/locale";

const LOCALES: { [key: string]: Locale } = {
  uk,
  en: enGB,
  ru,
  de,
  bg,
  zh: zhCN,
  nl,
  fr,
  hi,
  it,
  ja,
  pl,
  pt,
  ro,
  es,
  sv,
};

export const getLocaleByLangCode = (lang: string): Locale => LOCALES[lang];

// export const formatDateByLocale = (
//   date: Date,
//   formatStr: string,
//   locale: Locale
// ): string => {
//   return format(date, formatStr, { locale });
// };
